import React, { useMemo } from 'react';
import { Box, Typography, Button, CardMedia, Chip } from '@mui/material';
import ReactPlayer from 'react-player';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

const ImageUploadField = ({
  label,
  description,
  accept,
  autoConvertable = false,
  file,
  imageUrl,
  isVideo = false,
  onImageClick,
  onImageChange,
  onDelete,
  inputName,
}) => {
  const previewUrl = useMemo(() => {
    return file ? URL.createObjectURL(file) : imageUrl;
  }, [file, imageUrl]);

  const resolvedAccept = accept || (isVideo ? 'video/*' : 'image/*');

  return (
    <Box
      sx={{
        p: 2,
        border: autoConvertable ? '1px solid #b3d4f5' : '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: autoConvertable ? '#f5faff' : '#fafafa',
        width: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#212529' }}>
          {label}
        </Typography>
        {autoConvertable && (
          <Chip
            icon={<AutoFixHighIcon sx={{ fontSize: '14px !important' }} />}
            label="Auto Convert"
            size="small"
            sx={{
              fontSize: 10,
              height: 20,
              backgroundColor: '#e3f2fd',
              color: '#1565c0',
              '& .MuiChip-icon': { color: '#1565c0' },
            }}
          />
        )}
      </Box>
      {description && (
        <Typography variant="caption" sx={{ color: '#888', display: 'block', mb: 1.5 }}>
          {description}
        </Typography>
      )}

      {previewUrl && (
        <Box sx={{ borderRadius: 2, overflow: 'hidden', mb: 2, boxShadow: 2, width: '100%' }}>
          {isVideo ? (
            <ReactPlayer
              url={previewUrl}
              controls
              width="100%"
              height="240px"
              onClickPreview={() => onImageClick(previewUrl)}
            />
          ) : (
            <CardMedia
              component="img"
              src={previewUrl}
              alt={label}
              sx={{
                width: '100%',
                height: 240,
                objectFit: 'contain',
                borderRadius: 2,
                backgroundColor: '#fff',
                cursor: 'pointer',
              }}
              onClick={() => onImageClick(previewUrl)}
            />
          )}
        </Box>
      )}

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button variant="outlined" component="label" size="small">
          Upload {label}
          <input
            hidden
            type="file"
            accept={resolvedAccept}
            name={inputName}
            onChange={onImageChange}
          />
        </Button>

        {previewUrl && (
          <Button variant="text" color="error" size="small" onClick={onDelete}>
            Delete
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ImageUploadField;
